"use client";

import { CalendarDays } from "lucide-react";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import type { ReactNode } from "react";
import { buildBookDemoHref } from "@/core/marketing/book-demo";
import { marketingEvents } from "@/core/observability/marketing-analytics";
import { cn } from "@/lib/utils";

export function BookDemoLink({
  children = "Book demo",
  className,
  variant = "primary",
  location,
}: {
  children?: ReactNode;
  className?: string;
  variant?: "primary" | "secondary";
  location?: string;
}) {
  const searchParams = useSearchParams();
  const href = buildBookDemoHref(searchParams?.toString() ?? "");

  return (
    <Link
      href={href}
      data-marketing-event={marketingEvents.bookDemoClick}
      data-marketing-location={location}
      className={cn(
        "inline-flex h-11 items-center justify-center gap-2 rounded-md px-4 text-sm font-semibold transition",
        variant === "primary"
          ? "bg-[#d95c25] text-white shadow-sm hover:bg-[#bd4817]"
          : "border border-[#c7d4ce] bg-white text-[#1d332d] hover:bg-[#eef4f2]",
        className,
      )}
    >
      <CalendarDays size={17} />
      {children}
    </Link>
  );
}
